// it is used to invalidate the cache when the backend changes
export const CACHE_VERSION = '0.0.2'; 